import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import TableIsEmptyIcon from "assets/customIcons/emptyTable/TableIsEmptyIcon";
import { body1SemiBoldStyles, body2RegularStyles } from "shared";

import { EmptyStateProps } from "./types";

const EmptyState = ({ type }: EmptyStateProps) => {
    const { gray700 } = colors;

    const { t } = useTranslation();

    return (
        <div
            css={css({
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                lineHeight: "20px",
                padding: "32px 32px 68px 32px",

                "& > div:first-of-type": {
                    ...body1SemiBoldStyles,
                    margin: "16px 8px 8px"
                },

                "& > div:last-of-type": {
                    ...body2RegularStyles,
                    color: gray700,
                    margin: "0 8px"
                }
            })}
        >
            <TableIsEmptyIcon
                css={css({
                    fontSize: "120px"
                })}
            />

            <div>{t(`Dashboard##empty state##title##${type}`)}</div>
            <div>{t(`Dashboard##empty state##description##${type}`)}</div>
        </div>
    );
};

export default EmptyState;
